import httpRequest, { httpAnonymousRequest } from 'httpRequest'
import { CompanyContract, UpdateCompanyBasicInfoContract } from 'models'

const COMPANY_PREFIX = '/company'

const companyService = {
    getCurrentCompany() {
        return httpRequest.get<CompanyContract>(COMPANY_PREFIX)
    },
    updateCompany(payload: CompanyContract) {
        return httpRequest.put(COMPANY_PREFIX, payload)
    },
    getCompanyLogo() {
        return httpAnonymousRequest.get<string>(`${COMPANY_PREFIX}/logo`)
    },
    updateCompanyBaseInfo: (payload: UpdateCompanyBasicInfoContract) =>
        httpRequest.put(`${COMPANY_PREFIX}/base-info`, payload),
}

export default companyService
